export const cleanupTimes = [
	{
		key: 'voteanswers',
		date: '02.11.2022 12:00'
	}
];
